import axios from "@/api/axiosInstance";
import {
  ConnectionEventResult,
  RecordConnectionEventRequest,
  RecordConnectionEventResponse,
} from "./types";

export const recordConnectionEvent = async (
  requestData: RecordConnectionEventRequest,
): Promise<ConnectionEventResult> => {
  const response = await axios.post<RecordConnectionEventResponse>(
    "/api/private/data-connector/connection-events",
    requestData,
  );
  return response.data.data;
};
